module.exports = __webpack_public_path__ + "img/threeIcon.35d471a0.png";